import * as Yup from 'yup';

const validationSchema = (t) => {
  return Yup.object({
    weight: Yup.number()
      .min(40, t('measurements.weight.errorMessage', { min: '40 kg', max: '250 kg' }))
      .max(250, t('measurements.weight.errorMessage', { min: '40 kg', max: '250 kg' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(88, t('measurements.weight.errorMessage', { min: '88 lb', max: '551 lb' }))
            .max(551, t('measurements.weight.errorMessage', { min: '88 lb', max: '551 lb' }))
            .nullable(true),
      }),
    hip: Yup.number()
      .min(50, t('measurements.hip.errorMessage', { min: '50 cm', max: '250 cm' }))
      .max(250, t('measurements.hip.errorMessage', { min: '50 cm', max: '250 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(20, t('measurements.hip.errorMessage', { min: '20 in', max: '98 in' }))
            .max(98, t('measurements.hip.errorMessage', { min: '20 in', max: '98 in' }))
            .nullable(true),
      }),
    waist: Yup.number()
      .min(40, t('measurements.waist.errorMessage', { min: '40 cm', max: '250 cm' }))
      .max(250, t('measurements.waist.errorMessage', { min: '40 cm', max: '250 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(16, t('measurements.waist.errorMessage', { min: '16 in', max: '98 in' }))
            .max(98, t('measurements.waist.errorMessage', { min: '16 in', max: '98 in' }))
            .nullable(true),
      }),
    thigh: Yup.number()
      .min(30, t('measurements.thigh.errorMessage', { min: '30 cm', max: '150 cm' }))
      .max(150, t('measurements.thigh.errorMessage', { min: '30 cm', max: '150 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(12, t('measurements.thigh.errorMessage', { min: '12 in', max: '59 in' }))
            .max(59, t('measurements.thigh.errorMessage', { min: '12 in', max: '59 in' }))
            .nullable(true),
      }),
    rightthigh: Yup.number()
      .min(30, t('measurements.thigh.errorMessage', { min: '30 cm', max: '150 cm' }))
      .max(150, t('measurements.thigh.errorMessage', { min: '30 cm', max: '150 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(12, t('measurements.thigh.errorMessage', { min: '12 in', max: '59 in' }))
            .max(59, t('measurements.thigh.errorMessage', { min: '12 in', max: '59 in' }))
            .nullable(true),
      }),
    chest: Yup.number()
      .min(50, t('measurements.chest.errorMessage', { min: '50 cm', max: '200 cm' }))
      .max(200, t('measurements.chest.errorMessage', { min: '50 cm', max: '200 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(20, t('measurements.chest.errorMessage', { min: '20 in', max: '79 in' }))
            .max(79, t('measurements.chest.errorMessage', { min: '50 in', max: '200 in' }))
            .nullable(true),
      }),
    arm: Yup.number()
      .min(10, t('measurements.arm.errorMessage', { min: '10 cm', max: '100 cm' }))
      .max(100, t('measurements.arm.errorMessage', { min: '10 cm', max: '100 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(4, t('measurements.arm.errorMessage', { min: '4 in', max: '39 in' }))
            .max(39, t('measurements.arm.errorMessage', { min: '10 in', max: '100 in' }))
            .nullable(true),
      }),
    rightarm: Yup.number()
      .min(10, t('measurements.arm.errorMessage', { min: '10 cm', max: '100 cm' }))
      .max(100, t('measurements.arm.errorMessage', { min: '10 cm', max: '100 cm' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(4, t('measurements.arm.errorMessage', { min: '4 in', max: '39 in' }))
            .max(39, t('measurements.arm.errorMessage', { min: '10 in', max: '100 in' }))
            .nullable(true),
      }),
    bodyFat: Yup.number()
      .min(2, t('measurements.bodyFat.errorMessage', { min: '2%', max: '70%' }))
      .max(70, t('measurements.bodyFat.errorMessage', { min: '2%', max: '70%' }))
      .nullable(true),
    muscleMass: Yup.number()
      .min(10, t('measurements.muscleMass.errorMessage', { min: '10 kg', max: '150 kg' }))
      .max(150, t('measurements.muscleMass.errorMessage', { min: '10 kg', max: '150 kg' }))
      .nullable(true)
      .when('systemOfMeasures', {
        is: (value) => value && value === 'imperial',
        then: (schema) =>
          schema
            .min(22, t('measurements.muscleMass.errorMessage', { min: '22 lb', max: '330 lb' }))
            .max(330, t('measurements.muscleMass.errorMessage', { min: '22 lb', max: '330 lb' }))
            .nullable(true),
      }),
    visceralFat: Yup.number()
      .min(1, t('measurements.visceralFat.errorMessage', { min: '1', max: '50' }))
      .max(50, t('measurements.visceralFat.errorMessage', { min: '1', max: '50' }))
      .nullable(true),
  });
};

export default validationSchema;
